import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["listen"];
import React from 'react';
import { isServerEnvironment } from '../../common/utils';
import { useRouterStore } from '../router-store';
export const RouterSubscriber = ({
  children
}) => {
  const [state, _ref] = useRouterStore();
  const {
      listen
    } = _ref,
    actions = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!state.unlisten && !isServerEnvironment()) {
    listen();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(state, actions));
};